"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const classnames_1 = __importDefault(require("classnames"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const utils_1 = require("./utils");
const RecrAmountField = ({ classes, name, formikProps, isTypeGrossPaycheck }) => (<formik_1.Field name={name} validate={(value) => value === undefined || value === null || value === '' ? 'required' : undefined}>
    {({ field, form: { touched, errors, values } }) => (<AmountField_1.default {...field} onChange={(e) => {
            formikProps.setFieldValue('virtualAmount', (0, utils_1.setVirtualAmount)(formikProps.values, e.target.value));
            field.onChange(e);
        }} showSign={values.virtualShowSign} showAmountAdornment editable omitCents={false} currencySymbol="USD" amountType="amount" id="schedtxn-amount" label={name.includes('split') ? 'Amount' : 'Recurring Amount'} marginProp="normal" fullWidth autoComplete="off" error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} helperText={(0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name)} classes={{ inputField: (0, classnames_1.default)(classes.amtTxt) }} InputProps={{
            classes: { underline: classes.underlineOverride },
        }} disabled={isTypeGrossPaycheck}/>)}
  </formik_1.Field>);
exports.default = RecrAmountField;
